import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { for: "file-upload" }
const _hoisted_2 = { class: "flex h-full items-center" }
const _hoisted_3 = { class: "h-[48px] items-center flex outline-System/app_border hover:outline-System/app_primary rounded-sm outline outline-1 cursor-pointer w-[306px]" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Browse")
const _hoisted_5 = { class: "w-0 flex-grow flex p-2" }
const _hoisted_6 = { class: "truncate" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Upload ")

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediButton } from 'incredi-ui';
import { useUploadFile } from './uploadFile.helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'uploadFIle',
  props: {
    uploadFileCallback: null
  },
  setup(__props: any) {

const { fileContentBase64, fileName, isFileChosen, onFileChange } = useUploadFile();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("label", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("input", {
              "data-testid": "upload-file--input",
              id: "file-upload",
              hidden: "",
              type: "file",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onFileChange) && _unref(onFileChange)(...args)))
            }, null, 32),
            _createVNode(_unref(IncrediButton), {
              "data-testid": "upload-file--browse-button",
              class: "pointer-events-none !h-[48px]",
              size: "big"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(fileName)), 1)
            ])
          ]),
          _createVNode(_unref(IncrediButton), {
            "data-testid": "upload-file--upload-button",
            disabled: !_unref(isFileChosen) && !_unref(fileContentBase64),
            size: "big",
            class: "!mt-5 w-[306px] !rounded-[50px] block !h-[40px] !font-gordita-bold-italic",
            design: "primary-green",
            rouneded: "",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (__props.uploadFileCallback(_unref(fileContentBase64))), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})